import * as React from "react";
import { useState, useMemo } from "react";
import { Modal } from "components/bootstrap";
import { Icon } from "components/common";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useThreatRelatedIlluminatePacks from "security-app/components/common/ThreatCoverageWidget/ImproveCoverageModal/useThreatRelatedIlluminatePacks";
import PacksInstallStatus from "security-app/components/common/ThreatCoverageWidget/PacksInstallStatus";
import StepNavigation from "./StepNavigation";
import StepsOverview, { STEPS } from "./StepsOverview";
import IlluminatePacksEnable from "./IlluminatePacksEnable";
import EventDefinitionsEnable from "./EventDefinitionsEnable";
const useIlluminatePacksAreEnabled = () => {
  const { allPacks, notEnabledPacks, isInitialLoading } = useThreatRelatedIlluminatePacks();
  return {
    amountAllPacks: allPacks.length,
    amountNotEnabledPacks: notEnabledPacks.length,
    isIlluminatePacksAreEnabled: allPacks.length > 0 && notEnabledPacks.length === 0,
    isLoadingPacks: isInitialLoading
  };
};
const ImproveCoverageModal = ({
  onHide,
  coverageEntity = void 0,
  isTactic = void 0,
  initialStep = STEPS.overview.key
}) => {
  const [step, setStep] = useState(initialStep);
  const illuminatePacksAreEnabled = useIlluminatePacksAreEnabled();
  const sendTelemetry = useSendTelemetry("threat-coverage");
  const isEventDefinitionsStepAvailable = useMemo(
    () => !illuminatePacksAreEnabled.isLoadingPacks && illuminatePacksAreEnabled.amountNotEnabledPacks !== illuminatePacksAreEnabled.amountAllPacks,
    [
      illuminatePacksAreEnabled.amountAllPacks,
      illuminatePacksAreEnabled.amountNotEnabledPacks,
      illuminatePacksAreEnabled.isLoadingPacks
    ]
  );
  const onNextClicked = (nextStep) => {
    setStep(nextStep);
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.THREAT_COVERAGE.IMPROVE_COVERAGE_STEP_NEXT, {
      app_pathname: "security",
      event_details: { step: nextStep }
    });
  };
  return /* @__PURE__ */ React.createElement(Modal, { show: true, onHide, bsSize: "large" }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, STEPS[step].title(coverageEntity, isTactic))), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(PacksInstallStatus, null, step === "overview" && /* @__PURE__ */ React.createElement(
    StepsOverview,
    {
      illuminatePacksAreEnabled,
      setStep,
      coverageEntity,
      isTactic
    }
  ), step === STEPS.illuminatePacksEnable.key && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    StepNavigation,
    {
      setStep,
      nextButtonText: /* @__PURE__ */ React.createElement(React.Fragment, null, "Enable Event Definitions ", /* @__PURE__ */ React.createElement(Icon, { name: "arrow_right_alt" })),
      onClickNext: isEventDefinitionsStepAvailable ? () => onNextClicked(STEPS.eventDefinitionsEnable.key) : void 0
    }
  ), /* @__PURE__ */ React.createElement(IlluminatePacksEnable, null)), step === STEPS.eventDefinitionsEnable.key && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StepNavigation, { setStep, nextButtonText: "Close modal", onClickNext: onHide }), /* @__PURE__ */ React.createElement(EventDefinitionsEnable, { coverageEntity })))));
};
export default ImproveCoverageModal;
